import { render } from "./ButtonGroupHeader.vue?vue&type=template&id=1a7be7ee"
import script from "./ButtonGroupHeader.vue?vue&type=script&lang=js"
export * from "./ButtonGroupHeader.vue?vue&type=script&lang=js"

import "./ButtonGroupHeader.vue?vue&type=style&index=0&id=1a7be7ee&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__